import { Box, Button, Collapse, Typography, useTheme } from '@mui/material'
import { Icons, FLAT_LIGHT_COLORS, latexDelimiters } from '../../../utils/utilities'
import React, { useState } from 'react'
import ConfirmDialog from '../../common/ConfirmDialog'
import { useQuizAndQuestionbankStore } from '../../../store/quiz.store'
import Latex from 'react-latex-next'
import AddOrEditQuestionBankQuestionDialog from '../AddOrEditQuestionBankQuestionDialog'
import { convert } from 'html-to-text'

const colorListLength = FLAT_LIGHT_COLORS.length

const optionsList = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"

const QuestionBlock = ( { question, index, colors = false } ) => {

    const [open, setOpen] = useState( false )
    const [deleting, setDeleting] = useState( false )
    const [editQuestionDialogState, setEditQuestionDialogState] = useState( false )
    const [deleteDialogState, setDeleteDialogState] = useState( false )

    const QuizQuestionbankStore = useQuizAndQuestionbankStore()

    const { palette, border, shadows } = useTheme()

    const deleteQuestion = async () => {
        setDeleting( true )
        await QuizQuestionbankStore.deleteQuestion( question.question_bank_id, question.topic_id, question.id )
        setDeleteDialogState( false )
        setDeleting( false )
    }

    return (
        <Box bgcolor={palette.contentBg} border={border[1]} sx={{ borderColor: open ? palette.common.font : palette.borderColor, "&:hover": { boxShadow: shadows[1], borderColor: palette.common.font } }} borderRadius="5px">

            <ConfirmDialog waiting={deleting} status={deleteDialogState} cancelAction={() => setDeleteDialogState( false )} confirmAction={deleteQuestion} actionName="Yes, Delete it!" message={`Do you really want to delete this question?`} />
            {editQuestionDialogState && <AddOrEditQuestionBankQuestionDialog fromComponent="questionbank" setState={setEditQuestionDialogState} state={editQuestionDialogState} title={<Typography fontSize="inherit" maxWidth="40vw" noWrap><strong>Edit:</strong>  <em>{convert( question.question_text )}</em> </Typography>} mode='update' questionDetails={question} />}

            <Box sx={{ cursor: "pointer" }} display="flex" gap="10px" flexWrap="wrap" alignItems="flex-start">
                <Box flexGrow={1} onClick={() => setOpen( !open )} display="flex" gap="10px" alignItems="flex-start" padding="10px">
                    <Typography variant="subtitle2">{index + 1}</Typography>
                    <Box flexGrow={1}>
                        <Typography marginBottom="4px" fontSize="10px" color="secondary">{question.question_type}</Typography>
                        <Box sx={{ "& img": { maxWidth: "100%", objectFit: "cover" } }} className='questionbank-wysiwyg-container' fontWeight="bold" marginTop="-5px" fontSize="14px">
                            <Latex delimiters={latexDelimiters}>{question.question_text}</Latex>
                        </Box>
                    </Box>
                </Box>
                <Box margin="5px" display="flex" gap="10px" alignItems="center" flexWrap="wrap">
                    <Button color='greyed' onClick={() => setEditQuestionDialogState( true )} startIcon={Icons.default.EditIcon} sx={{ marginRight: "10px", textTransform: "capitalize" }}>
                        Edit
                    </Button>
                    <Button color='greyed' onClick={() => setDeleteDialogState( true )} startIcon={Icons.default.RemoveCircleIcon} sx={{ marginRight: "10px", textTransform: "capitalize" }}>
                        remove
                    </Button>
                </Box>

            </Box>
            <Collapse in={open}>
                <Box padding="10px" borderTop="1px solid #d3d3d3">
                    {question.options.map( ( option, optionIndex ) => {
                        const isCorrect = question.selection_type === "single" ? +question.correct_answer === optionIndex : question.options_status[optionIndex]
                        return (
                            <Box display="flex" marginBottom="2px" alignItems="flex-start" gap="10px" key={optionIndex}>
                                <Typography marginBottom="2px" variant="subtitle2" fontSize="12px" sx={{ aspectRatio: 1 / 1 }} display="flex" alignItems="center" justifyContent="center" width='20px' borderRadius="50%" margin="0" bgcolor={isCorrect && "success.light"} fontWeight={isCorrect ? "bolder" : "regular"} color={isCorrect ? "white" : "textSecondary"}>{optionsList[optionIndex]}</Typography>
                                <Box sx={{ "& img": { maxWidth: "100%", objectFit: "cover" } }} variant="subtitle2" className='questionbank-wysiwyg-container'>
                                    <Latex delimiters={latexDelimiters}>{option.option_text}</Latex>
                                </Box>
                            </Box>
                        )
                    } )}
                </Box>
            </Collapse>
        </Box >
    )
}


export default QuestionBlock
